module.exports = __webpack_public_path__ + "img/westernunion.9292b2e8.png";